"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledProducts = exports.StyledOlapicWidget = exports.Root = exports.EditorialRoot = exports.EditorialCarouselSectionRoot = exports.EditorialBannersRoot = exports.CarouselRoot = exports.CarouselInner = void 0;
var _mui = require("@ori-ui/mui");
var _editorialPage = require("@ori/editorial-page");
var _olapicLib = require("@ori/olapic-lib");
var _productList = require("@ori/product-list");
const EditorialBannersRoot = exports.EditorialBannersRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 'auto'),
        display: 'flex',
        flexDirection: 'column'
    };
});
const EditorialRoot = exports.EditorialRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        display: 'block'
    };
});
const CarouselRoot = exports.CarouselRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        display: 'block'
    };
});
const CarouselInner = exports.CarouselInner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        maxWidth: '1078px',
        margin: theme.spacing(0, 'auto')
    };
});
const EditorialCarouselSectionRoot = exports.EditorialCarouselSectionRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        maxWidth: '1078px',
        margin: theme.spacing(0, 'auto')
    };
});
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.spacing(4),
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(8)
        }
    };
});
const StyledProducts = exports.StyledProducts = (0, _mui.styled)(_editorialPage.Products)((param)=>{
    let { theme } = param;
    return {
        [".".concat(_productList.productListClasses.carousel)]: {
            paddingLeft: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(12)
            }
        },
        [".".concat(_productList.productListClasses.list)]: {
            padding: theme.spacing(0, 3)
        }
    };
});
const StyledOlapicWidget = exports.StyledOlapicWidget = (0, _mui.styled)(_olapicLib.OlapicWidget)((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        [theme.breakpoints.up('lg')]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6)
        }
    };
});
